import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[pcAutoFocusFirstEmpty]',
  standalone: true
})
export class AutoFocusFirstEmptyDirective {
  private el = inject(ElementRef);

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.focusFirstEmptyInput();
      event.preventDefault();
    }
  }

  private focusFirstEmptyInput(): void {
    const parentContainer = this.el.nativeElement.closest('.date-container');
    if (parentContainer) {
      const elements: HTMLInputElement[] = Array.from(parentContainer.querySelectorAll('input'));

      let firstEmptyElement: HTMLInputElement | undefined = undefined;

      firstEmptyElement = elements.find((value) => value.value === '');

      if (firstEmptyElement) {
        firstEmptyElement.focus();
      }
    }
  }
}
